import { Close } from "@mui/icons-material";
import { Typography } from "@mui/material";
import {
    Dialog,
    DialogActions,
    DialogContent,
    DialogTitle,
    Divider,
    IconButton,
} from "@vapor/react-material";
import { FormattedMessage } from "react-intl";
import Button from "../../../vapor/button";
interface ConfirmActionAlertProps {
    open: boolean;
    title: string;
    description: string;
    onConfirm: () => void;
    onCancel: () => void;
}

const ConfirmActionAlert = (props: ConfirmActionAlertProps) => {
    return (
        <Dialog
            open={props.open}
            onClose={(event, reason) => {
                props.onCancel();
            }}
        >
            <DialogTitle>
                {props.title}
                <IconButton color="primary" onClick={() => props.onCancel()}>
                    <Close />
                </IconButton>
            </DialogTitle>
            <Divider variant="fullWidth" />
            <DialogContent>
                <Typography>{props.description}</Typography>
            </DialogContent>
            <DialogActions>
                <Button
                    onClick={() => props.onCancel()}
                    kind="secondary"
                    size="medium"
                >
                    <FormattedMessage id="actions.cancel" />
                </Button>
                <Button onClick={() => props.onConfirm()} size="medium">
                    <FormattedMessage id="actions.confirm" />
                </Button>
            </DialogActions>
        </Dialog>
    );
};

export default ConfirmActionAlert;
